/**
 * Fahne (Markierung) sofort in der geladenen Liste umschalten — #36.
 *
 * Gemeldet 21.10.2026 (Marlene, Mail-ID 12015): „Fähnchen lässt sich nicht
 * entfernen". Der Server hatte jedes Mal richtig entmarkiert (zehnmal
 * „Markierung entfernt" in 18 Sekunden, `flagged` danach FALSE) — nur die
 * Zeile zeigte die Fahne weiter. Sie wartete auf das Neuladen der ganzen
 * Liste, und jeder weitere Klick startete dieses Neuladen von vorn.
 * Jetzt: die Zeile wechselt beim Klick, bei einem Fehler zurück mit Meldung.
 */
export type MitFahne = { id: number; flagged?: boolean | null; flag_note?: string | null }

export function fahneUmschalten<T extends { items?: MitFahne[] | null }>(
  daten: T | undefined, emailId: number, flagged: boolean, note: string | null,
): T | undefined {
  if (!daten?.items) return daten
  let geaendert = false
  const items = daten.items.map((e) => {
    if (e.id !== emailId) return e
    geaendert = true
    return { ...e, flagged, flag_note: flagged ? note : null }
  })
  return geaendert ? { ...daten, items } : daten
}
